import { createContext, useState } from 'react';
import api from 'services/api';

export const EntregasRealizarContext = createContext();

export const EntregasRealizarProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [entregasRealizar, setEntregasRealizar] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getEntregasRealizar = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: entregasRealizar?.filter,
        page: entregasRealizar?.page,
        size: entregasRealizar?.size,
        order: entregasRealizar?.order,
        ...payload,
      });
      setEntregasRealizar((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postNota = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Comercial/Entregas/Nota', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <EntregasRealizarContext.Provider
      value={{
        entregasRealizar,
        getLoading,
        getEntregasRealizar,
        postNota,
        postLoading,
      }}
    >
      {children}
    </EntregasRealizarContext.Provider>
  );
};
